
import log from 'salvo-lite/log'
import zenscroll from 'zenscroll'

class ScrollTo {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {

            ...JSON.parse(elem.getAttribute('data-scroll-to') || '{}')
        }

        this._selectors = {
            targetDesktop: '[data-scroll-to-target]',
            targetMobile: '[data-scroll-to-target-mobile]'
        }

        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            targetDesktop: document.querySelectorAll(this._selectors.targetDesktop),
            targetMobile: document.querySelectorAll(this._selectors.targetMobile)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._addEventListeners()

        window.addEventListener('resize', () => this._addEventListeners())
    }

    _addEventListeners () {
        const allTargets = [...this._nodeSelectors.targetDesktop, ...this._nodeSelectors.targetMobile]

        allTargets.forEach(target => {
            target.addEventListener('click', e => {
                this._handleScroll(e)
            })
        })
    }

    _handleScroll (e) {
        e.preventDefault()
        let selector = e.currentTarget.getAttribute('data-scroll-to-target')

        if (window.innerWidth <= 768) {
            selector = e.currentTarget.getAttribute('data-scroll-to-target-mobile')
        }

        if (!selector) return

        const targetElement = document.querySelector(selector)
        const top = targetElement.getBoundingClientRect().top + zenscroll.getY() - this._getHeaderHeight()
        zenscroll.toY(top, 999)
    }

    /**
     * Return the header height
     */
    _getHeaderHeight () {
        return window.__Theme.getSectionsByType('site-header')._currentHeight
    }
}

export default ScrollTo



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollTo.js